/** 
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Organization services
  Date: may 2020
**/

import API from '../utils/api';
import LocalStorageService from './localStorage';
const localStorageService = LocalStorageService.getService();
import { globalPageLimit } from '../constants/applicationConstants';

export const getOrgsList = (url) => {
  return API.get(`orgs/orgs?limit=${globalPageLimit.ORGS_LIMIT}`, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};

export const getOrgs = (id) => {
  return API.get(`orgs/orgs/${id}`, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};

export const addOrgs = (data) => {
  return API.post(`orgs/orgs`, data, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};

export const updateOrgs = (data) => {
  return API.put(`orgs/orgs/${encodeURIComponent(data.PK)}`, data, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};

export const addProductToOrg = (data) =>{
  const PK = data.PK;
  delete data.PK;
  return API.post(`orgs/assign/${encodeURIComponent(PK)}`, data, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
}
export const updateProductToOrg = (data) =>{
  const PK = data.PK;
  const SK = data.SK;
  delete data.PK;
  delete data.SK;
  return API.put(`orgs/assign/${encodeURIComponent(PK)}/${encodeURIComponent(SK)}`, data, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
}

export const updateTenantStatus = (data) => {
  return API.post(`settings/patch/orgs`, data, {
    headers: {
      Authorization: `Bearer ${LocalStorageService.getAccessToken()}`,
    },
  });
};
